export default "__VITE_ASSET__CUel$m2A__"